module.exports = __webpack_public_path__ + "static/media/2.45c40e8c.jpg";